PMW.mergePMW(PMW, {
  PAYMENT_VENDORS: {
    APPLE: 'apple',
    STRIPE: 'stripe',
  },
  IAP_PRODUCT_TYPES: {
    DOWNLOADS: 'downloads',
    CREDITS: 'credits',
    SUBSCRIPTIONS: 'subscriptions',
    SUBSCRIPTIONS_UPGRADE: 'subscriptions_upgrade',
    FREE_TRIALS: 'freeTrials',
  },
  IAP_PURCHASE_TYPES: {
    SUBSCRIPTION: 'subscription',
    CONSUMABLE: 'consumable',
  },
  appleAccountSubscriptionResponseHandler: function (successCb, errorCb, purchaseType, event) {
    if (event.detail.message === 'active') {
      if (purchaseType === PMW.IAP_PRODUCT_TYPES.SUBSCRIPTIONS_UPGRADE) {
        successCb();
      } else {
        errorCb();
      }
    } else {
      successCb();
    }
  },
  getAppleAccountSubscriptionStatus: function (purchaseType, successCb, errorCb) {
    window.webkit.messageHandlers.subscriptionStatus.postMessage({});
    document.addEventListener('subscriptionStatus', this.appleAccountSubscriptionResponseHandler.bind(this, successCb, errorCb, purchaseType), {once: true});
  },
  inAppPurchaseResponseHandler: function (successCb, errorCb, appleToken, event) {
    if (event.detail.message.status === 'success') {
      successCb(event.detail.message);
    } else if (event.detail.message.status === 'cancelled') {
      void window.PMW.writeLocal('user/removeApplePurchaseToken', {appleToken: appleToken});
      errorCb(false);
    } else {
      errorCb(true);
    }
  },
  showErrorMessage: function (message, errorCb) {
    PMW.openMessageModal({
      text: message,
      isModalBlocking: true,
      onClose: () => {
        errorCb(false);
      },
    });
  },
  initOrUpgradeAppleSubscription: function (productId, appleToken, successCb, errorCb) {
    window.webkit.messageHandlers.purchaseResponse.postMessage({
      itemId: productId,
      appleAccountToken: appleToken,
      purchaseType: PMW.IAP_PRODUCT_TYPES.SUBSCRIPTIONS,
    });
    document.addEventListener('purchaseResponse', this.inAppPurchaseResponseHandler.bind(this, successCb, errorCb, appleToken), {once: true});
  },
  isUserEligibleForSubscriptionPurchase: function (currentSubscription) {
    return !currentSubscription || currentSubscription.vendor === PMW.PAYMENT_VENDORS.APPLE || (currentSubscription.isInactive && !currentSubscription.awaitingPayment);
  },
  initiateIAPSubscriptionPurchase: async function (productId, token, purchaseType, successCb, errorCb) {
    Promise.all([
      window.PMW.writeLocal('user/getApplePurchaseToken', {token: token, purchaseType: PMW.IAP_PURCHASE_TYPES.SUBSCRIPTION}),
      window.PMW.readLocal('premium/getUserCurrentSubscriptionStatus'),
    ])
      .then(async ([appleToken, currentSubscription]) => {
        if (this.isUserEligibleForSubscriptionPurchase(currentSubscription)) {
          this.getAppleAccountSubscriptionStatus(
            purchaseType,
            this.initOrUpgradeAppleSubscription.bind(this, productId, appleToken, successCb, errorCb),
            this.showErrorMessage.bind(this, window.i18next.t('pmwjs_subscription_exists_on_device_apple_account'), errorCb)
          );
        } else {
          this.showErrorMessage(window.i18next.t('pmwjs_premium_subscription_already_active'), errorCb);
        }
      })
      .catch(() => {
        errorCb();
      });
  },
  handleIAPOneTimePurchase: function (productId, token, purchaseType, successCb, errorCb) {
    PMW.writeLocal('user/getApplePurchaseToken', {token: token, purchaseType: PMW.IAP_PURCHASE_TYPES.CONSUMABLE})
      .then((appleToken) => {
        window.webkit.messageHandlers.purchaseResponse.postMessage({
          itemId: productId,
          appleAccountToken: appleToken,
          purchaseType: purchaseType,
        });
        document.addEventListener('purchaseResponse', this.inAppPurchaseResponseHandler.bind(this, successCb, errorCb, appleToken), {once: true});
      })
      .catch(() => {
        errorCb();
      });
  },
  callBackForIAPurchase: function (productId, token, purchaseType, successCb, errorCb) {
    if (window.webkit && window.webkit.messageHandlers) {
      if (purchaseType === this.IAP_PRODUCT_TYPES.SUBSCRIPTIONS || purchaseType === this.IAP_PRODUCT_TYPES.SUBSCRIPTIONS_UPGRADE) {
        void this.initiateIAPSubscriptionPurchase(productId, token, purchaseType, successCb, errorCb);
      } else {
        this.handleIAPOneTimePurchase(productId, token, purchaseType, successCb, errorCb);
      }
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  onIAPProductsReceived: function (type, cb, resolve, reject, event) {
    const products = event.detail.message;
    if (products) {
      let decodedProducts = JSON.parse(
        '[' +
          products
            .replaceAll('[', '{')
            .replaceAll(']', '}')
            .slice(1, products.length - 1) +
          ']'
      );
      decodedProducts = decodedProducts.map((product) => {
        return {
          ...product,
          tierId: Number(product.tierId),
          duration: Number(product.duration),
          level: Number(product.level),
        };
      });
      PMW.setCacheItem(type, products, PMW.CACHE_EXPIRY_ONE_HOUR);
      cb(decodedProducts);
      resolve();
    } else {
      reject();
    }
  },
  getIAPProducts: async function (type, cb) {
    await new Promise((resolve, reject) => {
      const products = PMW.getVersionedCacheItem(type);
      if (products) {
        cb(products);
        resolve();
        return;
      }
      if (window.webkit && window.webkit.messageHandlers) {
        window.webkit.messageHandlers.productsResponse.postMessage({
          purchaseType: type,
        });
        document.addEventListener('productsResponse', this.onIAPProductsReceived.bind(this, type, cb, resolve, reject), {once: true});
      } else {
        PMW.openErrorModal({log: false});
        reject();
      }
    });
  },
  openIOSDeviceSubscriptions: function () {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.subscriptionSettings.postMessage({});
      const handler = (event) => {
        if (event.detail.message === 'error') {
          PMW.openMessageModal({
            text: window.i18next.t('pmwjs_manage_ios_subscription'),
          });
        }
        document.removeEventListener('subscriptionSettings', handler);
      };
      document.addEventListener('subscriptionSettings', handler);
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  openIOSDevicePurchaseHistory: function () {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.purchaseHistory.postMessage({});
      const handler = (event) => {
        if (event.detail.message === 'error') {
          PMW.openMessageModal({
            text: window.i18next.t('pmwjs_you_can_view_your_purchase_history_from_settings_or_app_store'),
          });
        }
        document.removeEventListener('purchaseHistory', handler);
      };
      document.addEventListener('purchaseHistory', handler);
    } else {
      PMW.openErrorModal({log: false});
    }
  },
  showSubscriptionHandlingInfo: async () => {
    const userId = PMW.getUserId();
    if (!userId || !PMW.isUserPremium()) {
      return false;
    }
    const vendor = await PMW.readLocal('premium/getActiveSubscriptionVendor');
    const showManageSubscriptionsDialog = (vendor === PMW.PAYMENT_VENDORS.APPLE && !PMW.isIOSApp()) || (vendor === PMW.PAYMENT_VENDORS.STRIPE && PMW.isIOSApp());
    if (showManageSubscriptionsDialog) {
      PMW.openMessageModal({
        title: window.i18next.t('pmwjs_manage_subscription'),
        text: window.i18next.t(PMW.isIOSApp() ? 'pmwjs_manage_subscription_web_or_android' : 'pmwjs_manage_subscription_ios_ipados'),
        ctaButton: {
          text: window.i18next.t('pmwjs_okay'),
          onClick: () => {
            PMW.closeMessageModal();
          },
        },
      });
      return true;
    }
    return false;
  },
});
